import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import Constants from "../Constants";
import useAxios from "./useAxios";
import { toaster } from "../utils/toast";
import { getCaseRouteMatch } from "../utils/helper";
import { HELP_CATEGORIES_MAP } from "@demandproai/shared";

const useHelpRequest = ({ onSuccess } = {}) => {
  const location = useLocation();
  const caseRouteMatch = getCaseRouteMatch(location.pathname);
  const caseId = caseRouteMatch?.params?.caseId;
  const route = `${location.pathname}${location.search}${location.hash}`;
  const { postData, isLoading } = useAxios();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const formik = useFormik({
    initialValues: {
      comment: "",
      category: HELP_CATEGORIES_MAP.OTHER?.value || "",
    },
    enableReinitialize: true,
    onSubmit: (values) =>
      submitHelpRequest({
        comment: values.comment.trim(),
        category: values.category,
      }),
  });

  const openHelpModal = () => setIsModalOpen(true);

  const closeHelpModal = () => {
    if (isLoading) return;
    setIsModalOpen(false);
  };

  const submitHelpRequest = async ({ comment, category }) => {
    const response = await postData(Constants.ApiUrl.help.request, {
      route,
      caseId,
      comment,
      category,
    });
    toaster({
      message:
        response?.message ||
        (response?.success
          ? "Help request submitted successfully"
          : "Failed to submit help request"),
      success: Boolean(response?.success),
    });
    if (response?.success) {
      formik.resetForm();
      setIsModalOpen(false);
      onSuccess?.(response);
    }
    return response;
  };

  return {
    openHelpModal,
    helpRequestModalProps: {
      isOpen: isModalOpen,
      onClose: closeHelpModal,
      isLoading,
      formik,
    },
    isLoading,
  };
};

export default useHelpRequest;
